import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Box, CircularProgress } from '@mui/material';
import { useGetProviderIntro } from '@queryHooks/useProviderIntro';
import { Introduction } from '../../../employee/introduction';
import { useProviderStoreContext } from './ProviderStoreContext';

/**
 * 프로바이더 스토어 전용 소개 페이지
 * - 판매자별 발행된 소개 페이지가 있으면 해당 콘텐츠 표시
 * - 없으면 기본 스플리터 Introduction 표시
 */
export const ProviderIntroduction = () => {
  const { i18n } = useTranslation();
  const { providerId } = useProviderStoreContext();
  const { data: introData, isLoading, isError } = useGetProviderIntro(providerId, i18n.language);

  // iframe에 삽입할 HTML 문서 생성
  const iframeSrcDoc = useMemo(() => {
    if (!introData?.content) return '';
    return `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <style>
            html, body {
              margin: 0;
              padding: 0;
              width: 100%;
              height: 100%;
            }
          </style>
        </head>
        <body>
          ${introData.content}
        </body>
      </html>
    `;
  }, [introData?.content]);

  if (isLoading) {
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );
  }

  // 발행된 소개 페이지가 없거나 에러인 경우 기본 Introduction 표시
  if (!introData?.content || isError) {
    return <Introduction />;
  }

  // 발행된 소개 페이지가 있으면 iframe으로 콘텐츠 표시
  return (
    <Container>
      <StyledIframe srcDoc={iframeSrcDoc} title="소개 페이지" sandbox="allow-scripts" />
    </Container>
  );
};

const LoadingContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
`;

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - var(--employee-gnb-height));
  height: 100%;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: calc(100vh - var(--employee-gnb-height));
  border: none;
`;
